import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  ", "\n\n  & ", " {\n    margin: 0 -", ";\n    padding-left: 0;\n    padding-right: 0;\n    padding-top: 0;\n  }\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  ", "\n\n  width: ", "; /* for nicer ripple effect */\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  ", "\n\n  & ", " {\n    color: ", ";\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  padding: ", " ", " ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Icon, Image } from '@scp/ui-shared/theme/icons';
import { withRippleEffect } from '@scp/ui-shared/theme/ripple-effect';
import { ClearedUl } from '@scp/ui-shared/theme/resets';
import { Heading3, Subtext } from '@scp/ui-shared/components/typography';
import { Menu } from '@scp/ui-shared/components/menu';
import { Logo } from '@scp/ui-shared/components/brand';
import { baselineToPx } from '@scp/ui-shared/theme/utils';
import { getE2eLabel } from '@scp/ui-shared/components/utils';
import { Spacing } from '@scp/ui-shared/components/layout/Spacing';
import { APP_BAR_RIPPLE_COLOR_BY_THEME, APP_BAR_SECTION_COLOR_BY_THEME } from './baseTypes';
import { sectionBase, barBase, logoRowBase, contentAfterLogoBase, navigationBase, menuWrapperBase, appLinkWrapperBase, linkStylesBase } from './baseStyles';
var TEXT = {
  APP_LINKS: 'More Apps',
  APP_LINK: function APP_LINK(name) {
    return "Open ".concat(name, " app in new tab");
  },
  LOGO: 'Go to home page',
  NAV_LABEL: 'App navigation'
};
var E2E = {
  ITEM_SUFFIX: '-bar',
  SECTION_SUFFIX: '-bar-section'
};
var SectionHeader = styled(Subtext).attrs({
  medium: true
})(_templateObject(), baselineToPx(5), baselineToPx(4), baselineToPx(4));
var Bar = styled.header(_templateObject2(), barBase, SectionHeader, function (props) {
  return APP_BAR_SECTION_COLOR_BY_THEME[props.colorTheme];
});
var LogoRow = styled.div(_templateObject3(), logoRowBase);
var ContentAfterLogo = styled.div(_templateObject4(), contentAfterLogoBase);
var Section = styled.div(_templateObject5(), sectionBase);
var LinkComponent = withRippleEffect('a');
var RouteComponent = withRippleEffect(Link);
var AppLink = styled(LinkComponent).attrs({
  target: '_blank'
})(_templateObject6(), linkStylesBase);
var LogoLink = styled(RouteComponent).attrs({
  to: '/',
  title: TEXT.LOGO,
  target: undefined
})(_templateObject7(), linkStylesBase, function (props) {
  return props.fullWidthLogo ? "100%" : "calc(100% + ".concat(baselineToPx(4), ")");
});
var Navigation = styled.nav.attrs({
  'aria-label': TEXT.NAV_LABEL
})(_templateObject8(), navigationBase);
var MenuWrapper = styled.div(_templateObject9(), menuWrapperBase, Section, baselineToPx(2));
var AppLinkWrapper = styled.li(_templateObject10(), appLinkWrapperBase);
export var AppNavigationBar = function AppNavigationBar(_ref) {
  var appMeta = _ref.appMeta,
      headerActions = _ref.headerActions,
      contentAfterLogo = _ref.contentAfterLogo,
      theme = _ref.theme,
      _ref$moreAppLinks = _ref.moreAppLinks,
      moreAppLinks = _ref$moreAppLinks === void 0 ? [] : _ref$moreAppLinks,
      children = _ref.children,
      dataE2e = _ref.dataE2e,
      _ref$fullWidthLogo = _ref.fullWidthLogo,
      fullWidthLogo = _ref$fullWidthLogo === void 0 ? false : _ref$fullWidthLogo;
  var rippleColor = APP_BAR_RIPPLE_COLOR_BY_THEME[theme];
  return React.createElement(Bar, {
    colorTheme: theme,
    "data-e2e": getE2eLabel('app-navigation', E2E.ITEM_SUFFIX, dataE2e)
  }, React.createElement(LogoRow, {
    fullWidthLogo: fullWidthLogo
  }, React.createElement(LogoLink, {
    rippleColor: rippleColor
  }, React.createElement(Logo, {
    name: appMeta.iconName,
    url: appMeta.productIconUrl,
    width: "auto",
    height: baselineToPx(8)
  })), headerActions), React.createElement(ContentAfterLogo, null, contentAfterLogo), React.createElement(Navigation, null, children), React.createElement(Spacing, {
    paddingHorizontal: 4,
    paddingTop: 6,
    paddingBottom: 6
  }, !!moreAppLinks.length && React.createElement("nav", {
    "aria-labelledby": "app-links"
  }, React.createElement(Heading3, {
    as: "p",
    id: "app-links"
  }, TEXT.APP_LINKS), React.createElement(ClearedUl, null, moreAppLinks.map(function (_ref2) {
    var url = _ref2.url,
        iconName = _ref2.iconName,
        name = _ref2.name,
        onClick = _ref2.onClick;
    return React.createElement(AppLinkWrapper, {
      key: name
    }, React.createElement(AppLink, {
      href: url,
      title: TEXT.APP_LINK(name),
      rippleColor: rippleColor,
      onClick: onClick
    }, React.createElement(Logo, {
      bold: true,
      withBoxWrapper: true,
      name: iconName,
      title: name,
      treatAccessibilityAsImage: false
    })));
  }))), appMeta.tenantIconUrl && React.createElement(Image, {
    url: appMeta.tenantIconUrl,
    width: baselineToPx(15),
    height: baselineToPx(11)
  }), !appMeta.tenantIconUrl && React.createElement(Icon, {
    name: "scp-health-logo-white-text",
    width: baselineToPx(15),
    height: baselineToPx(11)
  })));
};

var AppNavBarMenu = function AppNavBarMenu(props) {
  return React.createElement(MenuWrapper, null, React.createElement(Menu, Object.assign({
    darkBackground: true,
    roundedStyle: true,
    primary: true,
    noSpacing: true
  }, props)));
};

var AppNavBarSection = function AppNavBarSection(_ref3) {
  var children = _ref3.children,
      noSpacing = _ref3.noSpacing,
      showTopBorder = _ref3.showTopBorder,
      header = _ref3.header;
  return React.createElement(Section, {
    noSpacing: noSpacing,
    showTopBorder: showTopBorder
  }, header && React.createElement(SectionHeader, {
    "data-e2e": getE2eLabel(header, E2E.SECTION_SUFFIX)
  }, header), children);
};

AppNavigationBar.Menu = AppNavBarMenu;
AppNavigationBar.Section = AppNavBarSection;